import { render, staticRenderFns } from "./DashboardNotificationMenu.vue?vue&type=template&id=72facbe9&scoped=true&"
import script from "./DashboardNotificationMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardNotificationMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotificationMenu.vue?vue&type=style&index=0&id=72facbe9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72facbe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72facbe9')) {
      api.createRecord('72facbe9', component.options)
    } else {
      api.reload('72facbe9', component.options)
    }
    module.hot.accept("./DashboardNotificationMenu.vue?vue&type=template&id=72facbe9&scoped=true&", function () {
      api.rerender('72facbe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Dashboard/partials/DashboardNotificationMenu.vue"
export default component.exports